import { render, staticRenderFns } from "./modal-task-file-drag.vue?vue&type=template&id=4a5c85dc&scoped=true&"
import script from "./modal-task-file-drag.vue?vue&type=script&lang=ts&"
export * from "./modal-task-file-drag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5c85dc",
  null
  
)

export default component.exports